"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIAL_TYPE_TEXT = void 0;

var _socialType = require("./socialType");

var _SOCIAL_TYPE_TEXT;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SOCIAL_TYPE_TEXT = (_SOCIAL_TYPE_TEXT = {}, _defineProperty(_SOCIAL_TYPE_TEXT, _socialType.SOCIAL_TYPE.GOOGLE, 'Google'), _defineProperty(_SOCIAL_TYPE_TEXT, _socialType.SOCIAL_TYPE.MICROSOFT, 'Microsoft'), _defineProperty(_SOCIAL_TYPE_TEXT, _socialType.SOCIAL_TYPE.LINKED_IN, 'Linkedin'), _defineProperty(_SOCIAL_TYPE_TEXT, _socialType.SOCIAL_TYPE.APPLE, 'Apple'), _SOCIAL_TYPE_TEXT);
exports.SOCIAL_TYPE_TEXT = SOCIAL_TYPE_TEXT;